import {
  DocumentType,
  ModuleType,
  useGetDoLazyQuery,
  useGetDoPdfLazyQuery,
  useGetGoodReturnNoteLazyQuery,
  useGetGoodReturnNotePdfLazyQuery,
  useGetLetterTemplateByModuleLazyQuery,
  useGetPobdoLazyQuery,
  useGetPobGoodReturnNoteLazyQuery,
  useGetPobgrtNsLazyQuery,
  useGetPobPurchaseOrderLazyQuery,
  useGetPobPurchaseReqPdfLazyQuery,
  useGetPobrfqLazyQuery,
  useGetPurchaseOrderPdfLazyQuery,
  useGetPurchaseReqPdfLazyQuery,
  useGetRfqLazyQuery,
  useGetRfqPdfLazyQuery,
} from 'generated/graphql';
import React, { useEffect } from 'react';

export const usePurchaseQueries: any = ({
  accountType,
  CreditorDebtorAccountID,
  docType,
  companyID,
  transactionID,
  setErrDialog,
  setErrMessage,
  projectPurchasePOBSubscriber,
}) => {
  const [
    fetchLetterTemplate,
    {
      loading: letterTemplateLoading,
      called: letterTemplateCalled,
      data: { getLetterTemplateByModule } = { getLetterTemplateByModule: '' },
    },
  ] = useGetLetterTemplateByModuleLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
  });

  //----------AR Queries----------//
  const [
    fetchPurchaseReq,
    {
      loading: purchaseReqLoading,
      called: purchaseReqCalled,
      data: { getPurchaseReq } = { getPurchaseReq: [] },
    },
  ] = useGetPurchaseReqPdfLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
  });

  const [
    fetchPOBPurchaseReq,
    {
      loading: pobPurchaseReqLoading,
      called: pobPurchaseReqCalled,
      data: { getPOBPurchaseReq } = { getPOBPurchaseReq: [] },
    },
  ] = useGetPobPurchaseReqPdfLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
  });

  const [
    fetchPurchaseOrder,
    {
      loading: purchaseOrderLoading,
      called: purchaseOrderCalled,
      data: { getPurchaseOrder } = { getPurchaseOrder: [] },
    },
  ] = useGetPurchaseOrderPdfLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
  });

  const [
    fetchPOBPurchaseOrder,
    {
      loading: pobPurchaseOrderLoading,
      called: pobPurchaseOrderCalled,
      data: { getPOBPurchaseOrder } = { getPOBPurchaseOrder: [] },
    },
  ] = useGetPobPurchaseOrderLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
  });

  const [
    fetchDo,
    {
      loading: deliveryOrderLoading,
      called: deliveryOrderCalled,
      data: { getDO } = { getDO: [] },
    },
  ] = useGetDoPdfLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
  });

  const [
    fetchPOBDo,
    {
      loading: pobDeliveryOrderLoading,
      called: pobDeliveryOrderCalled,
      data: { getPOBDO } = { getPOBDO: [] },
    },
  ] = useGetPobdoLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
  });

  const [
    fetchGrtn,
    {
      loading: grtnLoading,
      called: grtnCalled,
      data: { getGoodReturnNote } = { getGoodReturnNote: [] },
    },
  ] = useGetGoodReturnNotePdfLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
  });

  const [
    fetchPOBGrtn,
    {
      loading: pobGrtnLoading,
      called: pobGrtnCalled,
      data: { getPOBGoodReturnNote } = { getPOBGoodReturnNote: [] },
    },
  ] = useGetPobGoodReturnNoteLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
  });

  const [
    fetchRFQ,
    {
      loading: rfqLoading,
      called: rfqCalled,
      data: { getRFQ } = { getRFQ: [] },
    },
  ] = useGetRfqPdfLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
  });

  const [
    fetchPOBRFQ,
    {
      loading: pobRfqLoading,
      called: pobRfqCalled,
      data: { getPOBRFQ } = { getPOBRFQ: [] },
    },
  ] = useGetPobrfqLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
  });

  let loading, called, listData, subMenuName, primaryKey;
  let templateBody = getLetterTemplateByModule;

  switch (docType) {
    case 'purchase-requisition':
      loading = projectPurchasePOBSubscriber
        ? pobPurchaseReqLoading
        : purchaseReqLoading;
      called = projectPurchasePOBSubscriber
        ? pobPurchaseReqCalled
        : purchaseReqCalled;
      listData = projectPurchasePOBSubscriber
        ? getPOBPurchaseReq
        : getPurchaseReq;
      subMenuName = 'Purchase Requisition';
      primaryKey = 'ID';
      break;
    case 'pr-on-behalf':
      loading = projectPurchasePOBSubscriber
        ? pobPurchaseReqLoading
        : purchaseReqLoading;
      called = projectPurchasePOBSubscriber
        ? pobPurchaseReqCalled
        : purchaseReqCalled;
      listData = projectPurchasePOBSubscriber
        ? getPOBPurchaseReq
        : getPurchaseReq;
      subMenuName = 'Purchase Requisition (On Behalf)';
      primaryKey = 'ID';
      break;
    case 'purchase-order':
    case 'direct-po':
      loading = projectPurchasePOBSubscriber
        ? pobPurchaseOrderLoading
        : purchaseOrderLoading;
      called = projectPurchasePOBSubscriber
        ? pobPurchaseOrderCalled
        : purchaseOrderCalled;
      listData = projectPurchasePOBSubscriber
        ? getPOBPurchaseOrder
        : getPurchaseOrder;
      subMenuName = 'Purchase Order';
      primaryKey = 'ID';
      break;
    case 'po-on-behalf':
    case 'direct-po-on-behalf':
      loading = projectPurchasePOBSubscriber
        ? pobPurchaseOrderLoading
        : purchaseOrderLoading;
      called = projectPurchasePOBSubscriber
        ? pobPurchaseOrderCalled
        : purchaseOrderCalled;
      listData = projectPurchasePOBSubscriber
        ? getPOBPurchaseOrder
        : getPurchaseOrder;
      subMenuName = 'Purchase Order (On Behalf)';
      primaryKey = 'ID';
      break;
    case 'delivery-order':
      loading = projectPurchasePOBSubscriber
        ? pobDeliveryOrderLoading
        : deliveryOrderLoading;
      called = projectPurchasePOBSubscriber
        ? pobDeliveryOrderCalled
        : deliveryOrderCalled;
      listData = projectPurchasePOBSubscriber ? getPOBDO : getDO;
      subMenuName = 'Official Receipt';
      primaryKey = 'ID';
      break;
    case 'good-return-note':
      loading = projectPurchasePOBSubscriber ? pobGrtnLoading : grtnLoading;
      called = projectPurchasePOBSubscriber ? pobGrtnCalled : grtnCalled;
      listData = projectPurchasePOBSubscriber
        ? getPOBGoodReturnNote
        : getGoodReturnNote;
      subMenuName = 'Refund';
      primaryKey = 'ID';
      break;
    case 'rfq':
      loading = projectPurchasePOBSubscriber ? pobRfqLoading : rfqLoading;
      called = projectPurchasePOBSubscriber ? pobRfqCalled : rfqCalled;
      listData = projectPurchasePOBSubscriber ? getPOBRFQ : getRFQ;
      subMenuName = 'RFQ';
      primaryKey = 'ID';
      break;
  }

  useEffect(() => {
    switch (docType) {
      case 'purchase-requisition':
        if (CreditorDebtorAccountID) {
          projectPurchasePOBSubscriber
            ? fetchPOBPurchaseReq({ variables: { ID: transactionID } })
            : fetchPurchaseReq({ variables: { ID: transactionID } });
        } else {
          projectPurchasePOBSubscriber
            ? fetchPOBPurchaseReq({ variables: { ID: transactionID } })
            : fetchPurchaseReq({ variables: { ID: transactionID } });
          fetchLetterTemplate({
            variables: {
              letterCategory: ModuleType.Pp,
              letterType: DocumentType.PurchaseRequisition,
              companyID: companyID,
            },
          });
        }
        break;
      case 'pr-on-behalf':
        if (CreditorDebtorAccountID) {
          projectPurchasePOBSubscriber
            ? fetchPOBPurchaseReq({ variables: { ID: transactionID } })
            : fetchPurchaseReq({ variables: { ID: transactionID } });
        } else {
          projectPurchasePOBSubscriber
            ? fetchPOBPurchaseReq({ variables: { ID: transactionID } })
            : fetchPurchaseReq({ variables: { ID: transactionID } });
          fetchLetterTemplate({
            variables: {
              letterCategory: ModuleType.Pp,
              letterType: DocumentType.PrOnBehalf,
              companyID: companyID,
            },
          });
        }
        break;
      case 'purchase-order':
      case 'direct-po':
        if (CreditorDebtorAccountID) {
          projectPurchasePOBSubscriber
            ? fetchPOBPurchaseOrder({ variables: { ID: transactionID } })
            : fetchPurchaseOrder({ variables: { ID: transactionID } });
        } else {
          projectPurchasePOBSubscriber
            ? fetchPOBPurchaseOrder({ variables: { ID: transactionID } })
            : fetchPurchaseOrder({ variables: { ID: transactionID } });
          fetchLetterTemplate({
            variables: {
              letterCategory: ModuleType.Pp,
              letterType: DocumentType.PurchaseOrder,
              companyID: companyID,
            },
          });
        }
        break;
      case 'po-on-behalf':
      case 'direct-po-on-behalf':
        if (CreditorDebtorAccountID) {
          projectPurchasePOBSubscriber
            ? fetchPOBPurchaseOrder({ variables: { ID: transactionID } })
            : fetchPurchaseOrder({ variables: { ID: transactionID } });
        } else {
          projectPurchasePOBSubscriber
            ? fetchPOBPurchaseOrder({ variables: { ID: transactionID } })
            : fetchPurchaseOrder({ variables: { ID: transactionID } });
          fetchLetterTemplate({
            variables: {
              letterCategory: ModuleType.Pp,
              letterType: DocumentType.PoOnBehalf,
              companyID: companyID,
            },
          });
        }
        break;
      case 'delivery-order':
        projectPurchasePOBSubscriber
          ? fetchPOBDo({ variables: { ID: transactionID } })
          : fetchDo({ variables: { ID: transactionID } });
        fetchLetterTemplate({
          variables: {
            letterCategory: ModuleType.Pp,
            letterType: DocumentType.Grn,
            companyID: companyID,
          },
        });
        break;
      case 'good-return-note':
        if (CreditorDebtorAccountID) {
          projectPurchasePOBSubscriber
            ? fetchPOBGrtn({ variables: { ID: transactionID } })
            : fetchGrtn({ variables: { ID: transactionID } });
        } else {
          projectPurchasePOBSubscriber
            ? fetchPOBGrtn({ variables: { ID: transactionID } })
            : fetchGrtn({ variables: { ID: transactionID } });
          fetchLetterTemplate({
            variables: {
              letterCategory: ModuleType.Pp,
              letterType: DocumentType.Grtn,
              companyID: companyID,
            },
          });
        }
        break;
      case 'rfq':
        if (CreditorDebtorAccountID) {
          projectPurchasePOBSubscriber
            ? fetchPOBRFQ({ variables: { ID: transactionID } })
            : fetchRFQ({ variables: { ID: transactionID } });
        } else {
          projectPurchasePOBSubscriber
            ? fetchPOBRFQ({ variables: { ID: transactionID } })
            : fetchRFQ({ variables: { ID: transactionID } });
          fetchLetterTemplate({
            variables: {
              letterCategory: ModuleType.Pp,
              letterType: DocumentType.Rfq,
              companyID: companyID,
            },
          });
        }
        break;
    }
  }, [accountType, docType]);

  return {
    loading,
    called,
    listData,
    subMenuName,
    primaryKey,
    templateBody,
    letterTemplateLoading,
  };
};
